import React from 'react';

const Store = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9 3H2.1V5H21.9V3ZM21.9 13V20C21.9 20.5523 21.4075 21 20.8 21H3.2C2.59249 21 2.1 20.5523 2.1 20V13H1V11L2.1 6H21.9L23 11V13H21.9ZM4.3 13V19H19.7V13H4.3ZM20.756 11H3.244L3.904 8H20.096L20.756 11ZM5.4 14H14.2V17H5.4V14Z"
      fill="#6A6A6A"
    />
  </svg>
);

export default Store;
